import requestUtil from '../../helpers/requestUtil';
import { setLoading } from '../common/Loader/slice';
import * as Toasts from '../common/Toastify';
import { updateSharedSlice } from '../shared/sharedSlice';
import {
  reset,
  resetError,
  resetParams,
  setError,
  setIsDataNotFound,
  setJobInfo,
  setJobPostedData,
  setLocationId,
  setLodingFlagDecrement,
  setLodingFlagIncrement,
  setMasterData,
  setMatchingCandidateInfo,
  setParams,
  setSavedJobShiftReleaseOrderIds,
  setshiftReleaseOderList,
  setshiftReleaseOderWaitTimeList,
  setTotalCount
} from './slice';

export const updateParams = (data) => {
  return async (dispatch) => {
    dispatch(setParams(data));
  };
};

export const resetParamVal = () => {
  return async (dispatch) => {
    dispatch(resetParams());
  };
};

export const getMatchingCandidateDetail = ({ url, params }) => {
  const newparams = { ...params };
  newparams.distance = params.distance ? parseInt(params.distance) : 0;
  newparams.searchStatus = params.searchStatus?.map((item) => item.id);
  newparams.matchingCriteria = params.matchingCriteria
    ? parseInt(params.matchingCriteria)
    : null;
  return async (dispatch) => {
    //dispatch(setLoading(true));
    try {
      dispatch(setLodingFlagIncrement());
      const response = await requestUtil(`${url}`, 'POST', { ...newparams });
      formartData(response.candidateSearchList);
      dispatch(setMatchingCandidateInfo(response.candidateSearchList));
      dispatch(setLocationId(response.locationId));
      dispatch(setJobInfo(response.jobInfo));
      dispatch(setTotalCount(response.totalCount));
      if(response?.candidateSearchList?.length === 0){
        dispatch(setIsDataNotFound(true))
      } else {
        dispatch(setIsDataNotFound(false))
      }
      if (response?.jobPosting) {
        dispatch(setJobPostedData(response?.jobPosting));
      }
      if (
        response?.jobPostingPriorities?.jobShiftReleaseOrderIds &&
        response?.jobPostingPriorities?.jobShiftReleaseOrderIds?.length
      ) {
        dispatch(
          setSavedJobShiftReleaseOrderIds(
            response?.jobPostingPriorities?.jobShiftReleaseOrderIds
          )
        );
      }
      dispatch(setLodingFlagDecrement());
      return response;
    } catch (error) {
      dispatch(setLodingFlagDecrement());
      dispatch(setError(error.message));
      dispatch(setIsDataNotFound(false))
    }
    //dispatch(setLoading(false));
  };
};

export const loadMasterData = (baseUrl) => {
  return async (dispatch, getState) => {
    const state = getState();
    // dispatch(setLoading(true));
    const { masterData } = state.matchingCandidateInfo;
    const distanceSharedList = state.shared.distanceSharedList;
    const statusSharedList = state.shared.statusSharedList;
    let travelDistance = distanceSharedList ?? [];
    let status = statusSharedList ?? [];
    let newstatus = statusSharedList?.length > 0 ?  statusSharedList?.filter(status => status?.name?.toLowerCase() !== "all") : [] 
    try {
      dispatch(setLodingFlagIncrement());

      if (status.length === 0) {
         status = await requestUtil(
          `${baseUrl}/Dropdown/get-candidate-status-for-employer-search`,
          'GET'
        );
        newstatus =  status?.filter(st => st?.name?.toLowerCase() !== "all") 
        dispatch(updateSharedSlice({name:"statusSharedList",value:status}));
      }
      if (travelDistance?.length === 0) {
         travelDistance = await requestUtil(`${baseUrl}/Dropdown/GetTravelDistances`,'GET');
         dispatch(updateSharedSlice({name:"distanceSharedList",value:travelDistance}));
      }
      if (masterData?.matchingCriteriaList?.length === 0) {
        const criteria = await requestUtil(
          `${baseUrl}/Employers/getmatchingcriteria`,
          'GET'
        );
        dispatch(setMasterData({ criteria }));
      }

      // if (!masterData?.travelDistanceList?.length) {
      //   const newstatus = await requestUtil(
      //     `${baseUrl}/Dropdown/get-candidate-status-for-employer-status-update-dropdown`,
      //     'GET'
      //   );
      //   
      // }
      dispatch(setMasterData({ travelDistance }));
      dispatch(setMasterData({ status }));
      dispatch(setMasterData({ newstatus }));
      // dispatch(setLoading(false));
      dispatch(setLodingFlagDecrement());
    } catch (error) {
      //dispatch(setLoading(false));
      dispatch(setError(error.message));
      dispatch(setLodingFlagDecrement());
    }
  };
};

const formartData = (data) => {
  data.map((item) => {
    item.shiftsCompleted = item.shiftsCompleted ? `${item.shiftsCompleted} Shifts` : "";
    item.hoursWorked = item.hoursWorked ? `${item.hoursWorked} Hours` : "";
  });
};

export const updateStatus = ({ url, params }) => {
  return async (dispatch) => {
    // dispatch(setLoading(true));
    try {
      dispatch(setLodingFlagIncrement());
      const response = await requestUtil(`${url}`, 'POST', { ...params });
      Toasts.success(response.message);
      dispatch(setLodingFlagDecrement());
       return response?.result ? true : false;
    } catch (error) {
      Toasts.error(error.message);
      dispatch(setError(error.message));
      dispatch(setLodingFlagDecrement());
      return false
    }
    //dispatch(setLoading(false));
  };
};

export const sendPostJob = ({ url, params }) => {
  return async (dispatch) => {
    let payload = params;
    if(params?.candidatesInfo?.length){
     const updatedCandidatesInfo =  params?.candidatesInfo?.map(candi => {
        if(candi?.hasOwnProperty("allowOverwrite")){
          return candi
        } else {
          return {...candi,allowOverwrite:true}
        }
      })
      payload = {...payload,candidatesInfo:updatedCandidatesInfo}
    }
    //dispatch(setLoading(true));
    try {
      dispatch(setLodingFlagIncrement());
      const response = await requestUtil(`${url}`, 'POST', { ...payload });
      Toasts.success(response.message);
      dispatch(setLodingFlagDecrement());
      return response;
    } catch (error) {
      dispatch(setError(error.message));
      dispatch(setLodingFlagDecrement());
      return error;
    }
    //dispatch(setLoading(false));
  };
};

// Send a Multiple Jobs Posting
export const sendPostMultipleJobs = ({ url, params }) => {
   let payload = params;
    if(params?.candidatesInfo?.length){
     const updatedCandidatesInfo =  params?.candidatesInfo?.map(candi => {
        if(candi?.hasOwnProperty("allowOverwrite")){
          return candi
        } else {
          return {...candi,allowOverwrite:true}
        }
      })
      payload = {...payload,candidatesInfo:updatedCandidatesInfo}
    }
  return async (dispatch) => {
    try {
      dispatch(setLodingFlagIncrement());
      const response = await requestUtil(`${url}`, 'POST', { ...payload });
      dispatch(setLodingFlagDecrement());
      return response;
    } catch (error) {
      dispatch(setError(error.message));
      dispatch(setLodingFlagDecrement());
      return error;
    }
  };
};

export const saveFavorite = ({ url, params }) => {
  return async (dispatch) => {
    //dispatch(setLoading(true));
    try {
      dispatch(setLodingFlagIncrement());
      const response = await requestUtil(`${url}`, 'POST', { ...params });
      Toasts.success(response.message);
      dispatch(setLodingFlagDecrement());
    } catch (error) {
      dispatch(setError(error.message));
      dispatch(setLodingFlagDecrement());
    }
    //dispatch(setLoading(false));
  };
};

export const getShiftRelaseOrder = ({ url }) => {
  return async (dispatch) => {
    //dispatch(setLoading(true));
    try {
      dispatch(setLodingFlagIncrement());
      const response = await requestUtil(
        `${url}/Jobs/get-job-shift-release-order`,
        'GET'
      );
      dispatch(setshiftReleaseOderList(response?.jobShiftReleaseOrderList));
      dispatch(setLodingFlagDecrement());
    } catch (error) {
      dispatch(setLodingFlagDecrement());
      dispatch(setError(error.message));
    }
    //dispatch(setLoading(false));
  };
};

export const getShiftRelaseOrderWaitTime = ({ url }) => {
  return async (dispatch) => {
    //dispatch(setLoading(true));
    try {
      dispatch(setLodingFlagIncrement());
      const response = await requestUtil(
        `${url}/Jobs/get-release-wait-time-options`,
        'GET'
      );
      //console.log(response);
      dispatch(setshiftReleaseOderWaitTimeList(response));
      dispatch(setLodingFlagDecrement());
    } catch (error) {
      dispatch(setError(error.message));
      dispatch(setLodingFlagDecrement());
    }
    //dispatch(setLoading(false));
  };
};

export const clearData = () => {
  return async (dispatch) => {
    dispatch(reset());
  };
};

export const AssignJobToCandidate = ({ url, params }) => {
  return async (dispatch) => {
    dispatch(setLodingFlagIncrement());
    try {
      const response = await requestUtil(`${url}`, 'POST', { ...params });
      Toasts.success(response.message);
      return response;
    } catch (error) {
      // Error message Convert to String 
      const convertToString = error.message.toLowerCase();
      const msg = 'The candidate was previously unclaimed from this shift. The shift cannot be assigned to this candidate';
      // If Not a Message got Tostify
      if (convertToString !== msg.toLowerCase()) {
        Toasts.error(error.message);
      }
      return error
    } finally {
      dispatch(setLodingFlagDecrement());
    }
  };
};

export const AssignJobToMultipleCandidate = ({ url, params }) => {
  return async (dispatch) => {
    try {
      dispatch(setLodingFlagIncrement());
      const response = await requestUtil(`${url}`, 'POST', { ...params });
      // Toasts.success(response.message);
      return response
    } catch (error) {
      // Toasts.error(error.message);
      return error
    } finally {
      dispatch(setLodingFlagDecrement());
    }
  };
};

export function getEmailDetails({ url }) {
  return async (dispatch) => {
    dispatch(setLodingFlagIncrement());
    try {
      const response = await requestUtil(`${url}`, "GET");
      return response;
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLodingFlagDecrement());
    }
  };
}

export function getSMSDetails({ url, params }) {
  return async (dispatch) => {
    dispatch(setLodingFlagIncrement());
    try {
      const response = await requestUtil(`${url}`, "POST", { ...params });
      return response;
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLodingFlagDecrement());
    }
  };
}

export function sendEmail({ url, params }) {
  return async (dispatch) => {
    dispatch(setLodingFlagIncrement());
    try {
      const response = await requestUtil(`${url}`, "POST", { ...params });
      Toasts.success("Email sent successfully!");
      return response;
    } catch (error) {
      Toasts.error("Email not sent!");
      return error.message;
    } finally {
      dispatch(setLodingFlagDecrement());
    }
  };
}

export function sendSMS({ url, params }) {
  return async (dispatch) => {
    dispatch(setLodingFlagIncrement());
    try {
      const response = await requestUtil(`${url}`, "POST", { ...params });
      Toasts.success("Sms sent successfully!");
      return response;
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLodingFlagDecrement());
    }
  };
}

export function sendAllEmailbtn(url) {
  return async (dispatch) => {
    dispatch(setLodingFlagIncrement());
    try {
      const response = await fetch(url);
      return response;
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLodingFlagDecrement());
    }
  };
}


export function sendAllSmsbtn(url) {
  return async (dispatch) => {
    dispatch(setLodingFlagIncrement());
    try {
      const response = await fetch(url);
      return response;
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLodingFlagDecrement());
    }
  };
}

export function getCallHistory(url, params) {
  return async (dispatch) => {
    dispatch(setLodingFlagIncrement());
    try {
      const response = await requestUtil(
        `${url}/Voice/get-recordings`,
        'POST', params
      );;
      return response;
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLodingFlagDecrement());
    }
  };
}

export const getOvertimeDetails = ({ url, params }) => {
  return async (dispatch) => {
    dispatch(setLodingFlagIncrement());
    try {
      const response = await requestUtil(url, "POST", { ...params });
      // console.log({response});
      //   const response = {
      //     "shiftWeeklyOvertimeList": [
      //         {
      //             "candidateOverLimtHours": 40,
      //             "remainingHours": "38:0",
      //             "workingHours": "1:0",
      //             "remainingMinutes":-2280,
      //             "weekStartDate": "11/26/2023 12:00 AM",
      //             "weekEndDate": "12/02/2023 11:59 PM"
      //         }
      //     ],
      //     "candidateName": "Ganesan Muthusamy",
      //     "isAllowedToClaim": false,
      //     "shiftLength": "1:0",
      //     "shiftStartDate": "12/01/2023 12:00 AM",
      //     "shiftEndDate": "12/01/2023 08:00 PM",
      //     "result": 1,
      //     "message": "Overtime Details Fetched Successfully.",
      //     "messagesParameters": null
      // }
      // const response = [
      //   {
      //     "shiftWeeklyOvertimeList": [
      //       {
      //         "candidateOverLimtHours": 40,
      //         "remainingHours": "-5:-0",
      //         "workingHours": "45:0",
      //         "remainingMinutes": -300,
      //         "weekStartDate": "11/26/2023 12:00 AM",
      //         "weekEndDate": "12/02/2023 11:59 PM"
      //       },
      //       {
      //         "candidateOverLimtHours": 40,
      //         "remainingHours": "40:0",
      //         "workingHours": "0:0",
      //         "remainingMinutes": 2400,
      //         "weekStartDate": "12/03/2023 12:00 AM",
      //         "weekEndDate": "12/09/2023 11:59 PM"
      //       },
      //       {
      //         "candidateOverLimtHours": 40,
      //         "remainingHours": "40:0",
      //         "workingHours": "0:0",
      //         "remainingMinutes": 2400,
      //         "weekStartDate": "12/10/2023 12:00 AM",
      //         "weekEndDate": "12/16/2023 11:59 PM"
      //       },
      //       {
      //         "candidateOverLimtHours": 40,
      //         "remainingHours": "40:0",
      //         "workingHours": "0:0",
      //         "remainingMinutes": 2400,
      //         "weekStartDate": "12/17/2023 12:00 AM",
      //         "weekEndDate": "12/23/2023 11:59 PM"
      //       }
      //     ],
      //     "candidateName": "Gowtest DEVnurse",
      //     "candidateUniqueId":  "cc9efd6e-55a0-4eb1-963a-1344a2644bc9",
      //     "isAllowedToClaim": false,
      //     "shiftLength": "0:0",
      //     "shiftStartDate": "12/25/2023 12:00 PM",
      //     "shiftEndDate": "12/22/2023 12:00 AM",
      //     "result": 1,
      //     "message": "Overtime Details Fetched Successfully.",
      //     "messagesParameters": null
      //   },
      //   {
      //     "shiftWeeklyOvertimeList": [
      //       {
      //         "candidateOverLimtHours": 40,
      //         "remainingHours": "-5:-0",
      //         "workingHours": "45:0",
      //         "remainingMinutes": -300,
      //         "weekStartDate": "11/26/2023 12:00 AM",
      //         "weekEndDate": "12/02/2023 11:59 PM"
      //       },
      //       {
      //         "candidateOverLimtHours": 40,
      //         "remainingHours": "40:0",
      //         "workingHours": "0:0",
      //         "remainingMinutes": -2400,
      //         "weekStartDate": "12/03/2023 12:00 AM",
      //         "weekEndDate": "12/09/2023 11:59 PM"
      //       },
      //       {
      //         "candidateOverLimtHours": 40,
      //         "remainingHours": "40:0",
      //         "workingHours": "0:0",
      //         "remainingMinutes": 2400,
      //         "weekStartDate": "12/10/2023 12:00 AM",
      //         "weekEndDate": "12/16/2023 11:59 PM"
      //       },
      //       {
      //         "candidateOverLimtHours": 40,
      //         "remainingHours": "40:0",
      //         "workingHours": "0:0",
      //         "remainingMinutes": 2400,
      //         "weekStartDate": "12/17/2023 12:00 AM",
      //         "weekEndDate": "12/23/2023 11:59 PM"
      //       }
      //     ],
      //     "candidateName": "Gowtest DEVnurse",
      //     "candidateUniqueId": "dd6d9e25-b354-4fea-bcbc-67f85f4289c8",
      //     "isAllowedToClaim": false,
      //     "shiftLength": "0:0",
      //     "shiftStartDate": "12/25/2023 12:00 PM",
      //     "shiftEndDate": "12/22/2023 12:00 AM",
      //     "result": 1,
      //     "message": "Overtime Details Fetched Successfully.",
      //     "messagesParameters": null
      //   }
      // ]
      return response
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLodingFlagDecrement());
    }
  }
}

// get Team List API
export const getTeamListDetails = (url) => {
  return async () => {
    try {
      const response = await requestUtil(url, "GET")
      return response
    } catch (error) {
      return error.message;
    }
  }
}


export const fetchDollarDetails = ({ url, params }) => {
  return async (dispatch) => {
    dispatch(setLodingFlagIncrement());
    try {
      const result = await requestUtil(url, "POST", { ...params });
      if (result?.result) {
        return result?.candidatePayRateSetupList
      }
    } catch (error) {
      return error
    } finally {
      dispatch(setLodingFlagDecrement());
    }
  }
}


export const mapDepartmentsToCandidate = ({ baseURL, mappedParams }) => {
  return async (dispatch) => {
    dispatch(setLodingFlagIncrement());
    try {
      const response = await requestUtil(`${baseURL}/Departments/map-department-candidate`, "POST", { ...mappedParams });
      Toasts.success(response?.message)
      return response?.result ? true : false;
    } catch (error) {
      Toasts.error(error?.message)
      return false;
    } finally {
      dispatch(setLodingFlagDecrement());
    }
  }
}

export const getMappedDepartmentsToCandi = ({ baseUrl, candidateUniqueId,locationId }) => {
  return async (dispatch) => {
    dispatch(setLodingFlagIncrement());
    try {
      const response = await requestUtil(`${baseUrl}/Departments/get-mapped-department-candidate?candidateUniqueIdId=${candidateUniqueId}&locationId=${locationId}`);
      return response?.departmentsMembersListList
    } catch (error) {
      return error?.message
    } finally {
      dispatch(setLodingFlagDecrement());
    }
  }
}


export const getTeamsByLocationDepartment = ({baseUrl,params}) => {
  return async(dispatch) => {
    dispatch(setLodingFlagIncrement());
    try {
      const response = await requestUtil(`${baseUrl}/TeamScheduling/get-teams-by-location-department`,"POST",{...params});
      return response
    } catch (error) {
      return error?.message
    }
    finally {
      dispatch(setLodingFlagDecrement());
    }
  }
}